import { useContext, useEffect } from "react";
import { ModalContext } from "contexts/modal-context";
import { modalTypes } from "blocks/modal-manager/modal-manager";
import { cleanup } from "@testing-library/react";
import { trackModalOpened } from "utils/posthogTracking";

export default function useModal() {
  const context = useContext(ModalContext);

  const openModal = (type, props = {}) => {
    context.setModalProps(props);
    context.setActiveModal(type);
    
    // Track modal opened event
    const trackingProps = {};
    
    // Extract relevant tracking data from modal props
    if (props.amount !== undefined) {
      trackingProps.amount = props.amount;
    }
    
    if (props.mode === "settlement-offer") {
      trackingProps.payment_type = "settlement_offer";
    } else if (props.mode === "payment-plan") {
      trackingProps.payment_type = "payment_plan";
    } else if (props.mode === "single-payment") {
      trackingProps.payment_type = "single";
    }
    
    trackModalOpened(type, trackingProps);
  };

  const closeModal = () => {
    context.setActiveModal(null);
    context.setModalProps({});
  };

  const isOpen = context.isOpen;

  return {
    ...context,
    openModal,
    closeModal,
    modalTypes,
    isOpen,
  };
}
